import React, { useState, useEffect } from "react";
import Layout from '../../../../component/layout/Layout'
import 'aos/dist/aos.css';
import AOS from 'aos';
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import firebaseConfig from "../../../firebase/firebaseConfig";

if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
}

const db = firebase.firestore();

const Oil = () => {
    const [cards, setCards] = useState([]);

    useEffect(() => {
        AOS.init({ duration: 1000 });

        // Fetch card data ordered by orderID
        const fetchCards = async () => {
            try {
                const snapshot = await db
                    .collection("oil_specialitychem")
                    .orderBy("orderID", "asc") // Order by 'orderID' in ascending order
                    .get();

                const cardData = snapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }));
                setCards(cardData);
            } catch (error) {
                console.error("Error fetching cards: ", error);
            }
        };

        fetchCards();
    }, []);

    const [activeSlide, setActiveSlide] = useState(0);

    const handleSlideChange = (index) => {
        setActiveSlide(index);
    };

    return (
        <Layout>
            <div className="bread">
                <ul className="collapsed">
                    <li><a href="/specialalitychem">Speciality Chemicals</a></li>
                    <li><a href="/">Home</a></li>
                </ul>
            </div>
            <section id="hero">
                <div id="heroCarousel" className="carousel slide carousel-fade" data-bs-interval="5000" data-bs-ride="carousel">
                    <ol className="carousel-indicators" id="hero-carousel-indicators">
                        <li
                            data-bs-target="#heroCarousel"
                            data-bs-slide-to="0"
                            className={activeSlide === 0 ? "active" : ""}
                            onClick={() => handleSlideChange(0)}
                        ></li>
                    </ol>
                    <div className="carousel-inner" role="listbox">
                        <div className={`carousel-item ${activeSlide === 0 ? "active" : ""}`} style={{ backgroundImage: "url(/img/oil-gas-cover-1024x576.jpg)" }}>
                            <div className="carousel-container">
                                <div className="container">
                                    <div className="text" id='text'>
                                        <h2 className="animate__animated animate__fadeInDown">Oil</h2>
                                        <p className="animate__animated animate__fadeInUp">To cope with the global demand and energy changing landscape, we provide our new advanced chemistries to support the oil sector to enhance the recovery, energy saving during completion, advance tailing management etc.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* textual data */}
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-12">
                        <div className="custom-block shop-detail-custom-block">
                            <h5 className="mb-3 mt-5">
                                The oil and gas industries are constantly seeking to increase the final percentage of hydrocarbons recovered from mature or newly exploited reservoirs.
                            </h5>
                            <ul>
                                <li>Thus multiplying the number of enhanced extraction projects around. Our product range RISHFLOC, RISHLYTE, RISHICIDE offer advance chemistries to support the oil and gas sector to enhance the recovery, energy saving & to keep environment Clean.</li>
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-6 col-12 m-auto">
                        <div className="custom-block shop-detail-custom-block">
                            <br /><br /><br />
                            <ul>
                                <li>Our range Flocculant, Coagulant, Dispersant, Rheology modifiers, Biocides & many other Specialty products find the applications in oilfield & Gas industry.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <br /><br />
            {/* table  */}
            <table
                className="table table-responsive-sm table-bordered table-striped"
            >
                <thead className="table table-dark">
                    <tr>
                        <th scope="col">Applications</th>
                        <th scope="col">RISHFLOC Flocculants</th>
                        <th scope="col">RISHLYTE Coagulants</th>
                        <th scope="col">RISHSCALE Scale Inhibitors</th>
                        <th>RISHFOAM Defoamer</th>
                        <th>RISHCIDE Microbial Control</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <th scope="row">Friction Reducer</th>
                        <td>&#10004;</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <th scope="row">De emulsifier</th>
                        <td></td>
                        <td>&#10004;</td>
                        <td></td>
                        <td>&#10004;</td>
                        <td></td>
                    </tr>
                    <tr>
                        <th scope="row">Viscocifier</th>
                        <td>&#10004;</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <th scope="row">Bentonite Extender</th>
                        <td>&#10004;</td>
                        <td>&#10004;</td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <th scope="row">Scale Inhibitors</th>
                        <td></td>
                        <td></td>
                        <td>&#10004;</td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <th scope="row">Fungicide</th>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>&#10004;</td>
                    </tr>
                    <tr>
                        <th scope="row">Algeacide</th>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>&#10004;</td>
                    </tr>
                </tbody>
            </table>

            {/* small cards */}
            <section id="services" className="services">
                <div className="container" data-aos="fade-up">
                    <div className="row">
                        {cards.map((card, index) => (
                            <div
                                key={card.id}
                                className="col-lg-4 col-md-6"
                                data-aos="zoom-in"
                                data-aos-delay={100 * (index + 1)}
                            >
                                <div className="icon-box">
                                    <h4>{card.title}</h4>
                                    <p>{card.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </Layout>
    )
}

export default Oil
